module.exports = __webpack_public_path__ + "7df52e4c451bde9a0d08f6fbf35459ab.svg";